import { useState } from "react";
import { Link } from "react-router-dom";
import { WalletContainerComponent } from "../wallet/WalletContainer";
import {
  NavbarContainer,
  LeftContainer,
  RightContainer,
  NavbarExtendedContainer,
  NavbarInnerContainer,
  NavbarLinkContainer,
  NavbarLink,
  Logo,
  OpenLinksButton,
  NavbarLinkExtended,
  CenterContainer,
  FillContainer,
} from "./styled-components";

function Navbar() {
  const [extendNavbar, setExtendNavbar] = useState(false);

  return (
    <NavbarContainer extendNavbar={extendNavbar}>
      <NavbarInnerContainer>
        <LeftContainer>
          <NavbarLinkContainer>
            <NavbarLink as={"a"} href="https://www.foreo.com/nft" target="_blank">Project</NavbarLink>
            <OpenLinksButton
              onClick={() => {
                setExtendNavbar((curr) => !curr);
              }}
            >
              {extendNavbar ? <>&#10005;</> : <> &#8801;</>}
            </OpenLinksButton>
          </NavbarLinkContainer>
        </LeftContainer>
        <CenterContainer as={"a"} href="https://www.foreo.com/" target="_blank">
          <Logo src="/FOREO_SWEDEN_logo_grey.svg" />
        </CenterContainer>
        <RightContainer>
          <WalletContainerComponent />
        </RightContainer>
        <FillContainer />
      </NavbarInnerContainer>
      {extendNavbar && (
        <NavbarExtendedContainer>
          <NavbarLinkExtended as={"a"} href="https://www.foreo.com/nft" target="_blank" onClick={() => setExtendNavbar(false)}>
            Project
          </NavbarLinkExtended>
          <WalletContainerComponent />
        </NavbarExtendedContainer>
      )}
    </NavbarContainer>
  );
}

export default Navbar;
